import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import actions from 'actions'
import Settings from 'components/Settings/Settings'
import { parseQueryString, buildQueryString, getEventsFileFromEnv, getSourceFileFromEnv } from 'utils/functions'
import v4 from 'uuid/v4'
import history from 'utils/history'

const envs = {
  host: process.env.MEDIA_STORE_HOST,
  bucket: process.env.MEDIA_STORE_ORIGIN_BUCKET
}

const getEventsFile = getEventsFileFromEnv(envs)
const getSourceFile = getSourceFileFromEnv(envs)

class SettingsContainer extends Component {
  constructor () {
    super(...arguments)

    this.onLoadSettings = this.onLoadSettings.bind(this)

    if (window.historyUnlisten) window.historyUnlisten()
    window.historyUnlisten = history.listen(() => { this.onHistoryListen() })
  }

  componentWillMount () {
    const {
      webinar_id,
      preroll_url = '',
      postroll_url = '',
      thumbnail_url = '',
      watermark_url = '',
      mode
    } = parseQueryString()
    let { webinar_url, meta_url = '' } = parseQueryString()

    if (webinar_id) {
      if (!webinar_url) {
        webinar_url = getSourceFile(webinar_id)
      }
      if (!meta_url) {
        meta_url = getEventsFile(webinar_id)
      }
      this.onLoadSettings({
        webinar_id,
        webinar_url,
        meta_url,
        preroll_url,
        postroll_url,
        thumbnail_url,
        watermark_url,
        mode
      })
    }
  }

  async onLoadSettings (data) {
    const {
      setMediaParams,
      generateMetaForEdit,
      readEvents
    } = this.props

    setMediaParams(data)

    if (!data.meta_url) {
      return false
    }

    try {
      const result = await readEvents({ metaUrl: data.meta_url })

      generateMetaForEdit({ uniqueFunc: v4, data: result.value })
    } catch (error) {
      const { mode } = parseQueryString()
      let replaceUrl = `?${buildQueryString()}`

      if (mode) replaceUrl += `&mode=${mode}`

      sessionStorage.setItem('mediaEditor_notification', 'failedReadEvents')
      history.replace(replaceUrl)
    }
  }

  onHistoryListen () {
    const {
      webinar_id,
      webinar_url,
      meta_url = '',
      preroll_url = '',
      postroll_url = '',
      thumbnail_url = '',
      watermark_url = '',
      mode
    } = parseQueryString()

    if (webinar_id && webinar_url && meta_url) {
      this.onLoadSettings({
        webinar_id,
        webinar_url,
        meta_url,
        preroll_url,
        postroll_url,
        thumbnail_url,
        watermark_url,
        mode
      })
    } else {
      this.setDefaultState()
    }
  }

  setDefaultState () {
    const { setMediaParams, setInitialState } = this.props
    const {
      webinar_id = '',
      webinar_url = '',
      meta_url = '',
      preroll_url = '',
      postroll_url = '',
      thumbnail_url = '',
      watermark_url = '',
      mode
    } = parseQueryString()
    const initialState = {
      meta: {
        data: [],
        isLoaded: false,
        isLoading: false,
        editData: {},
        activeItem: null
      },
      player: {
        isPlayerLoaded: false,
        playerElement: null,
        dts: null
      },
      timeline: {
        cuts: [],
        activeCutId: null
      },
      notificationStatus: sessionStorage.getItem('mediaEditor_notification') || null
    }

    setMediaParams({
      webinar_id,
      webinar_url,
      meta_url,
      preroll_url,
      postroll_url,
      thumbnail_url,
      watermark_url,
      mode
    })
    if (!webinar_id && !webinar_url && !meta_url) {
      setInitialState({ initialState })
    }
    sessionStorage.removeItem('mediaEditor_notification')
  }

  render () {
    return (
      <Settings />
    )
  }
}

const {
  func
} = PropTypes

SettingsContainer.propTypes = {
  setMediaParams: func.isRequired,
  generateMetaForEdit: func.isRequired,
  readEvents: func.isRequired,
  setInitialState: func.isRequired
}

export default connect(null, {
  setMediaParams: actions.settings.setMediaParams,
  readEvents: actions.media.readEvents,
  generateMetaForEdit: actions.media.generateMetaForEdit,
  setInitialState: actions.media.setInitialState
})(SettingsContainer)



// WEBPACK FOOTER //
// ./src/containers/SettingsContainer/SettingsContainer.js